var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { Link } from 'react-router';
import { Translate } from "../../../../../I18N";
import { Button, ConfirmationModal } from "../../../../Components/UI";







const DeletionModal = ({ confirmCallback, setConfirmCallback }) => /*#__PURE__*/
_jsx(ConfirmationModal, {
  header: /*#__PURE__*/_jsx(Translate, {}, void 0, "Delete"),
  warningText: /*#__PURE__*/_jsx(Translate, {}, void 0, "Are you sure you want to delete this item?"),
  body: /*#__PURE__*/
  _jsx(Translate, { className: "py-4 text-wrap" }, void 0, "Changes in the thesaurus will impact all the entities using these values."

  ),

  onCancelClick: () => {
    setConfirmCallback(undefined);
  },
  onAcceptClick: () => {
    confirmCallback.callback(confirmCallback.arg);
    setConfirmCallback(undefined);
  },
  dangerStyle: true }
);


const ThesaurusActions = ({ disabled }) => /*#__PURE__*/
_jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
_jsx(Link, { to: "/settings/thesauri" }, void 0, /*#__PURE__*/
_jsx(Button, { styling: "light", type: "button", disabled: disabled }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Cancel")
)
), /*#__PURE__*/
_jsx(Button, { styling: "solid", color: "success", type: "submit", form: "edit-thesaurus", disabled: disabled }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Save")
)
);


export { DeletionModal, ThesaurusActions };